import { render, staticRenderFns } from "./manage-request-products-by-seller.modal.vue?vue&type=template&id=5742b35a&scoped=true&"
import script from "./manage-request-products-by-seller.modal.vue?vue&type=script&lang=js&"
export * from "./manage-request-products-by-seller.modal.vue?vue&type=script&lang=js&"
import style0 from "./manage-request-products-by-seller.modal.vue?vue&type=style&index=0&id=5742b35a&lang=scss&scoped=true&"
import style1 from "./manage-request-products-by-seller.modal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742b35a",
  null
  
)

export default component.exports